/** @file The sort depth of one impostor: view depth of its point A minus its z bias (raster's key). */
import type { ImpostorList } from '@zilo/pose3d-render-core/contract';
import { viewDepth } from '@zilo/pose3d-render-core/camera/viewDepth';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import { IMPOSTOR_LAYOUT as L } from '@zilo/pose3d-render-core/layout/impostorLayout';

/** `viewDepth(A) - zBias` of impostor `index` (units, grows away from the camera). */
export function quadDepth(list: ImpostorList, index: number, view: View): number {
  const o = index * L.stride;
  const a = [list[o + L.ax] ?? 0, list[o + L.ay] ?? 0, list[o + L.az] ?? 0] as const;
  return viewDepth(a, view) - (list[o + L.zBias] ?? 0);
}
